import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

function BodyClassManager() {
  const location = useLocation();

  useEffect(() => {
    // Generate a class like "page-home" or "page-about"
    const path = location.pathname === '/' ? 'home' : location.pathname.replaceAll('/', '-');
    const className = `page${path}`;
    
    document.body.className = className; // reset to only that class
  }, [location]);

  return null;
}

export default BodyClassManager;